import { mutatorAction } from "satcheljs";
import { shiftEditorViewState } from "..";

export default mutatorAction("updateThemeOpenShift", function updateThemeOpenShift(theme: string) {
    if (shiftEditorViewState().openShift) {
        shiftEditorViewState().openShift.theme = theme;
    }
});